module.exports = __webpack_public_path__ + "media/tacklebox/assets/images/views/search/lines/yellow-c72c73f56fe7fe22bce61fad98a9372a.webp";